import { Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { ILandingSection, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import changeSectionDesignType from "../landing-edit/utils/changeSectionDesignType"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface ISectionTypeChangerProps {
   section: ILandingSection
}
const SectionTypeChanger = (props: ISectionTypeChangerProps): JSX.Element => {
    const currentLanding = useLandingStore((state: ILandingStore) => state.currentLanding)
    const section: ILandingSection = currentLanding.sections.find((s: ILandingSection) => s.id === props.section.id)
    const onChangeType = ( type: SECTION_DESIGN_TYPE ) => {
        changeSectionDesignType( section, type )
    }
    return <div className=" pt-2 d-flex flex-wrap column-4 width-200">
        {
            Object.values( SECTION_DESIGN_TYPE ).map( type => {
                return <div key={type} className="w-25 p-1 mb-1 hover pointer" onClick={ () => onChangeType( type ) } >
                    <Tooltip
                        intent="primary"
                        position="top-left"
                        content={<div className="small">
                            { __( type ) } 
                        </div>}
                    >
                        <img
                            alt=""
                            src={`/assets/img/landing/design_type_${type}.svg`}
                            width={ 45 }
                            className={ section?.designType === type ? "" : `opacity_5`}
                        />
                    </Tooltip> 
                </div> 
            })
        }
    </div>
}
export default SectionTypeChanger